export default {
      id: "oc-onecloud-map-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-onecloud-map",
      toString: function () {
        return this.url;
      }
    }